import styled from 'styled-components';
import { Divider } from '@mui/material';
export const StyledDivider = styled(Divider) `
  margin: ${({ theme }) => theme.spacing(1, 2)};
`;
